const topics = [
  { name: '庆余年第二季', heat: '热搜TOP1', count: '3580万讨论', color: 'bg-primary-100 text-primary-700' },
  { name: '流浪地球2', heat: '火爆', count: '2150万播放', color: 'bg-accent-100 text-accent-700' },
  { name: '长风渡全集', heat: '新上', count: '1280万追剧', color: 'bg-secondary-100 text-secondary-700' },
  { name: '古装剧推荐', heat: '热门', count: '960万搜索', color: 'bg-primary-100 text-primary-700' },
  { name: '国产科幻', heat: '飙升', count: '820万话题', color: 'bg-accent-100 text-accent-700' },
  { name: '悬疑剧单', heat: '新晋', count: '750万浏览', color: 'bg-secondary-100 text-secondary-700' },
  { name: '高分韩剧', heat: '经典', count: '680万收藏', color: 'bg-primary-100 text-primary-700' },
  { name: '周末影单', heat: '推荐', count: '550万互动', color: 'bg-accent-100 text-accent-700' },
  { name: '动漫大全', heat: '持续热', count: '490万追番', color: 'bg-secondary-100 text-secondary-700' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3">
            热门话题
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-extrabold text-foreground-900">
            全网热议的影视话题
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            追剧人群都在讨论什么？看看最新热门话题
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4">
          {topics.map((topic, idx) => (
            <div
              key={idx}
              className="group flex items-center gap-3 px-4 py-3 rounded-xl border border-background-200/70 bg-background-50 hover:border-accent-300 hover:bg-accent-50/30 transition-all duration-200 cursor-pointer"
            >
              <span className={`whitespace-nowrap px-2 py-0.5 rounded-full text-xs font-bold ${topic.color}`}>
                {topic.heat}
              </span>
              <div className="text-left">
                <span className="block text-sm font-heading font-semibold text-foreground-800 group-hover:text-primary-500 transition-colors whitespace-nowrap">
                  #{topic.name}
                </span>
                <span className="block text-xs text-foreground-400">{topic.count}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}